/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ComponentPropsWithoutRef, useMemo } from 'react';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import type { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
import { useEntryPointSubscription } from '@jira/platform__entry-points-point-subscription/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type {
	AnyEntryPoint,
	// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
	RuntimePropsOfEntryPoint,
	// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
} from '@jira/platform__entry-point/src/common/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { EntryPointActions } from '@jira/platform__entry-point/src/controllers/utils/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { InternalEntryPointContainer } from '@jira/platform__entry-points-internal-container/src/index.tsx';

interface Props<TEntryPoint extends AnyEntryPoint> extends Omit<
	ComponentPropsWithoutRef<typeof JiraEntryPointContainer<TEntryPoint>>,
	'fallback' | 'runtimeProps'
> {
	entryPointActions: EntryPointActions;
	runtimeProps: Omit<RuntimePropsOfEntryPoint<TEntryPoint>, 'onClose'> & { onClose?: () => void };
}

/**
 * @deprecated Use Modal EntryPoint API instead instead. https://go/modal-entry-point-api
 * */
export const ModalEntryPointContainer = <TEntryPoint extends AnyEntryPoint>({
	entryPointActions: { unload },
	entryPointReferenceSubject,
	errorFallback,
	runtimeProps,
	...containerProps
}: Props<TEntryPoint>): React.JSX.Element => {
	const entryPointReference = useEntryPointSubscription<TEntryPoint>(entryPointReferenceSubject);
	const props = useMemo(
		() =>
			// oxlint-disable-next-line typescript/consistent-type-assertions
			({
				...runtimeProps,
				onClose() {
					runtimeProps.onClose?.();
					unload();
				},
			}) as RuntimePropsOfEntryPoint<TEntryPoint>,
		[runtimeProps, unload],
	);

	return (
		<ModalTransition>
			{entryPointReference && (
				<InternalEntryPointContainer
					{...containerProps}
					entryPointReference={entryPointReference}
					errorFallback={errorFallback || 'flag'}
					placeholderName="modal-entry-point-container"
					runtimeProps={props}
				/>
			)}
		</ModalTransition>
	);
};
